import type { ReactNode } from 'react'
import { Link, useLocation } from 'react-router'

import { Button } from '@/components/ui/button'

import { memberPath, signupHref, SUPPLIER_NETWORK_PATH } from './network-path'

export function PublicShell({ children }: { children: ReactNode }) {
  const { pathname } = useLocation()

  return (
    <div className='flex min-h-dvh flex-col bg-page'>
      <header className='sticky top-0 z-20 flex min-h-14 items-center gap-2 border-b border-border bg-page px-4 pt-[env(safe-area-inset-top)] sm:px-6'>
        <Link
          to={SUPPLIER_NETWORK_PATH}
          className='flex min-w-0 items-center gap-2 text-ink no-underline'
        >
          <img src='/logo.png' alt='' className='size-7 shrink-0' />
          <span className='text-sm font-semibold'>TandemOne</span>
          <span className='hidden truncate text-sm text-muted-foreground sm:inline'>
            Supplier Network
          </span>
        </Link>
        <div className='ml-auto flex shrink-0 items-center gap-2'>
          <Button asChild variant='outline' size='hero'>
            <Link
              to={`/login?next=${encodeURIComponent(memberPath(pathname))}`}
            >
              Log in
            </Link>
          </Button>
          <Button asChild size='hero'>
            <Link to={signupHref(pathname)}>Sign up</Link>
          </Button>
        </div>
      </header>
      <main className='flex w-full flex-1 flex-col p-4 pb-[max(1rem,env(safe-area-inset-bottom))] sm:p-6'>
        {children}
      </main>
    </div>
  )
}
